import { Field } from "formik";
import React, { useState } from "react";
import { Form, FormText, InputGroup } from "react-bootstrap";
import { MdCheckCircle } from "react-icons/md";
import { Constants } from "../../libs/Constants";
import {
  checkForNumbers,
  checkForSymbols,
  checkForUpperCase
} from "../../libs/utils";
const errorMessages = [
  {
    error: "12 Characters Minimum",
    state: false,
  },
  {
    error: "Contains a small Letter",
    state: false,
  },
  {
    error: "Contains a Capital Letter",
    state: false,
  },
  {
    error: "Contains a Number",
    state: false,
  },
  {
    error: "Contains a Symbol (,./?::!$%&*=+)",
    state: false,
  },
];

const FormikTextField = ({
  as,
  md,
  size,
  controlId,
  label,
  name,
  type,
  inputGroupPrepend,
  inputGroupAppend,
  className,
  disabled,
  placeholder,
  required,
  min,
  helpText,
}) => {
  const [errors, setErrors] = useState(errorMessages);

  const validateResetForm = (password) => {
    let checks = errorMessages;
    for (let item of checks) item.state = false;
    checks[0].state =
      password.length >= Constants.PASSWORD_LENGTH ? true : false;
    checks[1].state = /[a-z]/.test(password);
    checks[2].state = checkForUpperCase(password);
    checks[3].state = checkForNumbers(password);
    checks[4].state = checkForSymbols(password);
    setErrors(checks);
  };

  return (
    <>
      <Field
        name={name}
        render={({ field, form }) => {
          const isValid = !form.errors[field.name];
          const isInvalid = form.touched[field.name] && !isValid;
          return (
            <Form.Group
              as={as}
              md={md}
              controlId={controlId}
              className={`form-group ${className}`}
            >
              <Form.Label>
                {label} {required && <span className="text-danger">*</span>}
              </Form.Label>
              <InputGroup>
                <Form.Control
                  size={size}
                  {...field}
                  disabled={disabled}
                  type={type}
                  placeholder={placeholder || label}
                  isInvalid={isInvalid}
                  feedback={form.errors[field.name]}
                  value={field.value}
                  min={min}
                  onChange={(e) => {
                    form.setFieldValue(name, e.target.value);
                    validateResetForm(e.target.value);
                  }}
                />
                {inputGroupAppend}
                <Form.Control.Feedback type="invalid">
                  {form.errors[field.name]}
                </Form.Control.Feedback>
                <Form.Text id={controlId} className="text-info" muted>
                  {helpText}
                </Form.Text>
              </InputGroup>
            </Form.Group>
          );
        }}
      />
      {errors.map((item, index) => {
        return (
          <div className="mb-1" key={index}>
            <FormText className={!item.state ? "passwordError text-danger" : "passwordOK text-muted"}>
              <MdCheckCircle
                className={!item.state ? "checkBoxOutline" : "checkBox"}
              />
              {item.error}
            </FormText>
          </div>
        );
      })}
    </>
  );
};

FormikTextField.defaultProps = {
  type: "text",
  inputGroupPrepend: null,
};

export default FormikTextField;
